import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Home, Search, Sparkles } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <main className="nf-page">
            <span className="nf-blob nf-blob--one" aria-hidden="true" />
            <span className="nf-blob nf-blob--two" aria-hidden="true" />

            <Link to="/" className="nf-logo" aria-label="Gettimelam Matrimony home">
                <img src="/logo-sm.webp" alt="Gettimelam Matrimony" />
            </Link>

            <section className="nf-card" aria-labelledby="nf-title">
                <div className="nf-art" aria-hidden="true">
                    <span className="nf-digit">4</span>
                    <span className="nf-zero">
                        <span className="nf-zero__ring" />
                        <span className="nf-zero__heart"><Heart size={46} fill="currentColor" /></span>
                        <Sparkles className="nf-spark nf-spark--a" size={20} />
                        <Sparkles className="nf-spark nf-spark--b" size={14} />
                    </span>
                    <span className="nf-digit">4</span>
                </div>

                <p className="nf-eyebrow">Page not found</p>
                <h1 id="nf-title">This match isn’t here.</h1>
                <p className="nf-text">
                    We couldn’t find <b>{pathname}</b>. The link may be broken or the page may have moved —
                    let’s get you back to finding your perfect match.
                </p>

                <div className="nf-actions">
                    <button type="button" className="nf-btn nf-btn--primary" onClick={() => navigate('/')}><Home size={16} /> Back to home</button>
                    <button type="button" className="nf-btn" onClick={() => navigate('/browse')}><Search size={16} /> Browse profiles</button>
                    <button type="button" className="nf-btn nf-btn--ghost" onClick={() => navigate(-1)}><ArrowLeft size={16} /> Go back</button>
                </div>
            </section>
        </main>
    );
};

export default NotFound;
